import React from 'react';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import Icon from '../../../components/AppIcon';

const ShipmentCard = ({ shipment, onSelect, getStatusBadge, getCarrierName }) => {
  const latestEvent = shipment?.trackingEvents?.[0];

  return (
    <div 
      className="bg-card rounded-xl p-6 border border-border hover:shadow-organic transition-shadow cursor-pointer"
      onClick={() => onSelect(shipment)}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="text-lg font-semibold text-foreground">
              {getCarrierName(shipment?.carrier)}
            </h3>
            {getStatusBadge(shipment?.currentStatus)}
          </div>
          <p className="text-sm text-muted-foreground font-mono">
            Takip No: {shipment?.trackingNumber}
          </p>
        </div>
        <Icon name="ChevronRight" size={20} className="text-muted-foreground" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Sipariş ID</p>
          <p className="text-sm font-medium text-foreground truncate">
            {shipment?.orderId?.substring(0, 8)}...
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Mevcut Konum</p>
          <p className="text-sm font-medium text-foreground">
            {shipment?.currentLocation || 'Bilgi bekleniyor'}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Tahmini Teslimat</p>
          <p className="text-sm font-medium text-foreground">
            {shipment?.estimatedDeliveryDate 
              ? format(new Date(shipment?.estimatedDeliveryDate), 'dd MMM yyyy', { locale: tr })
              : 'Belirtilmedi'
            }
          </p>
        </div>
      </div>

      {latestEvent && (
        <div className="bg-gray-50 rounded-lg p-3">
          <div className="flex items-start gap-2">
            <Icon name="Clock" size={16} className="text-muted-foreground mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground mb-1">
                {latestEvent?.eventDescription}
              </p>
              <p className="text-xs text-muted-foreground">
                {format(new Date(latestEvent?.eventTimestamp), 'dd MMMM yyyy, HH:mm', { locale: tr })}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShipmentCard;